import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import MaintenanceMode from "./views/MaintenanceMode";
import NoNetworkFallbackUI from "./views/NoNetworkFallback";
import RoutesComponent from "./routes";
import { Toaster } from "react-hot-toast";

const App = () => {
  const [isOnline, setIsOnline] = useState(window.navigator.onLine); // to check network status
  const [maintenanceMode, setMaintenanceMode] = useState(false); // Set this to true when maintenance is required

  //testing for auto commit build 7-1

  useEffect(() => {
    const handleConnectionChange = () => {
      setIsOnline(window.navigator.onLine);
    };
    window.addEventListener("online", handleConnectionChange);
    window.addEventListener("offline", handleConnectionChange);
    return () => {
      window.removeEventListener("online", handleConnectionChange);
      window.removeEventListener("offline", handleConnectionChange);
    };
  }, []);

  useEffect(() => {
    const disableRightClick = (event) => {
      event.preventDefault();
    };

    // Attach the event listener when the component mounts
    document.addEventListener("contextmenu", disableRightClick);

    // Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
    };
  }, []); // Empty dependency array ensures that the effect runs only once when the component mounts

  return maintenanceMode ? (
    <MaintenanceMode />
  ) : (
    <>
      {isOnline ? (
        <Router>
          <RoutesComponent />
        </Router>
      ) : (
        // Render the fallback UI component
        <NoNetworkFallbackUI />
      )}
      <Toaster />
    </>
  );
};

export default App;
